/**
 * Time interval constants used across time selection components.
 * Changing these values will automatically update all components that use them.
 */

/**
 * Default time interval in minutes for TimeSelect dropdown options.
 * This determines the granularity of time selections (e.g., 15 = 15-minute intervals: 0, 15, 30, 45).
 */
export const TIME_SELECT_INTERVAL_MINUTES = 15;

/**
 * Minimum time adjustment in minutes when adjusting start/end times
 * to prevent invalid time ranges (e.g., when start > end or end < start).
 */
export const MIN_TIME_ADJUSTMENT_MINUTES = 15;
